import React from 'react';
import { StyledReactTooltip } from './index.styled';

export const Tooltip = props => (
    <StyledReactTooltip {...props} suppressClassNameWarning />
);
